const isAlphanumeric = (value) =>
  value && !String(value).match(/^[a-z0-9\s]+$/i) && "Only alphanumeric characters allowed";

export default isAlphanumeric;
